export function getOrderTrackingId(order) {
  return (
    order?.blinkTrackingId
    || order?.courierTrackingId
    || order?.shipbluTrackingId
    || order?.bostaTrackingId
    || order?.orderFulfillment?.trackingId
    || null
  );
}

function normalizeCourierLabel(courier) {
  if (courier == null || courier === "") {
    return null;
  }

  const key = String(courier).trim().toLowerCase().replace(/\s+/g, "");
  if (key === "bosta") {
    return "Bosta";
  }
  if (key === "shipblu") {
    return "ShipBlu";
  }
  if (key === "fincart") {
    return "Fincart";
  }
  if (key === "blink") {
    return "Blink";
  }

  return String(courier).trim();
}

function isKnownShippingService(label) {
  return label === "Bosta" || label === "ShipBlu" || label === "Fincart" || label === "Blink";
}

function labelFromShippingService(shippingService, order) {
  if (!shippingService) {
    return null;
  }

  const normalized = normalizeCourierLabel(shippingService);
  if (normalized === "Fincart") {
    return order?.fincartCourier || "Fincart";
  }

  return normalized;
}

/**
 * Shipping service (Blink / Bosta / ShipBlu / Fincart) from order tracking/courier signals.
 * Partner shippingService is fallback only when the order has no tracking.
 * Blink/SDD orders must show Blink even when the brand default is another carrier.
 */
export function getOrderShippingServiceLabel(order, vendor) {
  if (order?.blinkTrackingId || order?.sameDayDelivery || order?.blinkId) {
    return "Blink";
  }

  if (order?.courier) {
    const normalized = normalizeCourierLabel(order.courier);
    if (isKnownShippingService(normalized)) {
      return normalized;
    }
  }

  if (order?.bostaTrackingId) {
    return "Bosta";
  }
  if (order?.shipbluTrackingId) {
    return "ShipBlu";
  }
  if (order?.fincartId || order?.courierTrackingId) {
    return "Fincart";
  }

  const shippingService = vendor?.shippingService || order?.vendor?.shippingService;
  return normalizeCourierLabel(shippingService);
}

/**
 * Resolve the courier label for a specific order.
 * Order-owned courier/tracking signals win; partner shippingService is fallback only.
 * For Fincart, prefers the underlying courier name (fincartCourier) when present.
 */
export function getOrderCourierLabel(order, vendor) {
  if (order?.blinkTrackingId || order?.sameDayDelivery || order?.blinkId) {
    return "Blink";
  }

  if (order?.courier) {
    const normalized = normalizeCourierLabel(order.courier);
    if (normalized === "Fincart" && order?.fincartCourier) {
      return order.fincartCourier;
    }
    return normalized;
  }

  if (order?.bostaTrackingId) {
    return "Bosta";
  }
  if (order?.shipbluTrackingId) {
    return "ShipBlu";
  }
  if (order?.fincartId || order?.courierTrackingId) {
    return order?.fincartCourier || "Fincart";
  }

  const shippingService = vendor?.shippingService || order?.vendor?.shippingService;
  return labelFromShippingService(shippingService, order);
}
